import React from 'react';
import get from 'lodash/get';
import moment from 'moment';
import styled from 'styled-components';
import StyledCheckbox from '../checkbox/StyledCheckbox';
import StyledRadioButton from '../radio/StyledRadioButton';

const TableBody = ({
  data,
  columns,
  selectedRows,
  checkBox,
  ref,
  loading,
  contentLoading = false,
  handleRowClick,
  formListings,
  setSelectedRows
}) => {
  const renderCell = (item, column) => {
    if (column.content) return column.content(item, contentLoading);
    if (column.path === 'createdAt' || column.path === 'updatedAt') {
      return formatDate(get(item, column.path));
    }
    return get(item, column.path) ?? '-';
  };

  const createKey = (item, column) => {
    // return (item?.id || 1) + (column?.path || column?.key) + Math.random();
    return `${item.id}-${column.content || column.path}`;
  };
  const formatDate = (date) => moment(new Date(date)).format('Do MMM YYYY');
  const totalRows  = data?.length; // Check if the row is the last one
  return (
    <StyledTBody ref={ref}>
      {data?.map((item, index) => (
        <tr key={`row-${index}`} ref={ref}>
          {checkBox && (
            <td ref={ref} className='align-middle'>
              {formListings ? (
                <StyledRadioButtonWrap>
                  <StyledRadioButton
                    title={'false'}
                    size="12"
                    className="ms-1 mt-1 me-0"
                    value={selectedRows?.includes(item?.id)? true: false}
                    type ={'documentstyles'} 
                    disabled={false}
                    onChange={() => setSelectedRows(selectedRows?.includes(item?.id)?[]:[item?.id])}
                  />
                </StyledRadioButtonWrap>
              ) : (
                <StyledCheckbox
                  className={`ms-2 mt-2 me-2 ${(item?.GDPRDeleted || item._source?.candidateStatus === 44) ? 'pe-none' : ''}`}
                  size={15}
                  value={selectedRows?.includes(item)}
                  onChange={() => {
                    handleRowClick(item);
                  }}
                />
              )}
            </td>
          )}

          {columns?.map((column) => (
            <td key={createKey(item, column)} className={` ${column.alignBody} ${index >= totalRows - 3 ? "last-row" : ""}`} >
              {renderCell(item, column)}
            </td>
          ))}
        </tr>
      ))}
    </StyledTBody>
  );
};

const StyledTBody = styled.tbody`
  tr {
    position: relative;
    z-index: 1;
    filter: ${({ theme }) =>
      theme?.dark
        ? 'drop-shadow(4px 5px 8px rgba(0, 0, 0, 0.35))'
        : 'drop-shadow(4px 5px 8px rgba(13, 35, 73, 0.16))'};

    /* filter creates a stacking context per row, so later cards paint over
       earlier ones' menus. Lift the row that has an open dropdown. */
    &:has(.dropdown.show),
    &:has(.custom-drop-down.show) {
      z-index: 20;
    }
  }

  td {
    padding: 8px 16px;
    vertical-align: middle;
    font-size: ${({ theme }) => theme.fontSizeBase};
    color: ${({ theme }) => theme.tableText};
    background-color: ${({ theme }) =>
      theme?.dark ? theme.tableRowBg || theme.cardBg : theme.white || '#fff'} !important;
    box-shadow: none !important;
    border: none;
    background-clip: padding-box;
    border-bottom: none !important;
    /* Gap between row cards only. border-spacing would also open a strip
       above the header, so the header would not sit on the parent edge. */
    border-top: 6px solid transparent;
    transition: background-color 0.15s ease;
  }

  td h5,
  td h6,
  td label,
  td p {
    color: inherit !important;
  }

  tr > td:first-child {
    overflow: hidden;
    border-left: 16px solid transparent !important;
    border-top-left-radius: 26px 10px;
    border-bottom-left-radius: 26px 10px;
  }

  /* Team Employees column: drop cell padding so the navy select tile is
     flush with the top and bottom of the row card. height: 1px is the
     table-cell trick that lets the inner flex fill the row height. */
  td.employee-select-cell {
    padding: 0 !important;
    height: 1px;
    vertical-align: top;
  }

  tr > td:last-child {
    overflow: visible;
    border-right: 16px solid transparent !important;
    border-top-right-radius: 26px 10px;
    border-bottom-right-radius: 26px 10px;
  }

  tr:last-child > td {
    border-bottom-width: ${({ theme }) => (theme?.dark ? '0' : '0')} !important;
  }

  tr:hover > td {
    background-color: ${({ theme }) =>
      theme?.dark ? '#4C535B' : theme.surfaceSubtle || '#F5F5F5'} !important;
  }

  td .custom-drop-down .menu-toggle,
  td .text-actionIcons {
    color: ${({ theme }) => theme.actionsIconColor} !important;
  }

  td .custom-drop-down svg [stroke]:not([stroke='none']),
  td .text-actionIcons [stroke]:not([stroke='none']) {
    stroke: currentColor;
  }

  td .custom-drop-down svg [fill]:not([fill='none']),
  td .text-actionIcons [fill]:not([fill='none']) {
    fill: currentColor;
  }
`;

const StyledRadioButtonWrap= styled.div`
&>label{
margin-right: 0px !important;
}
`

export default TableBody;
